<template>
  <div class="event-add-container">
    <div class="detail-conta" v-if="isDetail">
      <CommonDetail
        :configArray="
          addType == 0
          ?stockRightConfig
          :addType == 1?quitConfig
          :addType == 2?bonusConfig
          :addType == 3?contributionConfig
          :distributionConfig"
        :initValue="formData"
      >
        <template #files>
          <div class="file-content">
            <!-- <WordUpload
              @showFileName="showFileName"
              fileMenuName="动态文件"
              :readonly="true"
              :id="eventId&&eventId!=''?eventId:inventedId"
              :plain="false"
              :tip="true"
              :show-file-list="true"
            /> -->
            <div class="" v-if="fileLists.length>0">
              <div v-for="(item, index) in fileLists" :key="index">
                <div class="file_wrapper" >
                  <a
                    class="file_button"
                    target="_blank"
                    :href="item.fileUrl.indexOf('http://') < 0?'http://doc.taizhoujintou.com:18888/office/xdoc?doc='+item.fileUrl:item.fileUrl"
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'file')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </template>      
      </CommonDetail>
    </div>
    <div class="form-container" v-else>
      <!-- 股权投资 -->
      <avue-form
        v-if="addType == 0"
        ref="basicInfo"
        v-model="formData"
        :option="investConfig['stockRightConfig']"
      >
        <template slot="investCost">
          <el-tooltip class="item" effect="dark" :content="changesNumber['investCost']" placement="top-start">
            <el-input placeholder="请输入本轮基金投资成本" v-model="formData['investCost']" @input="getNumMoney('investCost')">
              <template slot="prepend">￥</template>
            </el-input>
          </el-tooltip>
        </template>
        <template slot="stockRatio">
          <el-input placeholder="请输入本轮投后持股比例" v-model="formData['stockRatio']">
            <template slot="append">%</template>
          </el-input>
        </template>
        <template slot="files">
          <!-- :readonly="userInfo.user_id != form.meetingManager" -->
          <div class="file-content">
            <WordUpload
              @showFileName="showFileName"
              fileMenuName="动态文件"
              :id="eventId&&eventId!=''?eventId:inventedId"
              :plain="true"
              :tip="true"
            />
            <div class="" v-if="fileLists.length>0">
              <div v-for="(item, index) in fileLists" :key="index">
                <div class="file_wrapper" :key="index">
                  <a
                    class="file_button"
                    target="_blank"
                    :href="item.fileUrl.indexOf('http://') < 0?'http://doc.taizhoujintou.com:18888/office/xdoc?doc='+item.fileUrl:item.fileUrl"
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'file')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </avue-form>

      <!-- 股权退出 -->
      <avue-form
        v-if="addType == 1"
        ref="basicInfo"
        v-model="formData"
        :option="investConfig['quitConfig']"
      >
        <template slot="quitCost">
          <el-tooltip class="item" effect="dark" :content="changesNumber['quitCost']" placement="top-start">
            <el-input placeholder="请输入本轮基金退出成本" v-model="formData['quitCost']" @input="getNumMoney('quitCost')" />
          </el-tooltip>
        </template>

        <template slot="income">
          <el-tooltip class="item" effect="dark" :content="changesNumber['income']" placement="top-start">
            <el-input placeholder="请输入本轮基金投资收益" v-model="formData['income']" @input="getNumMoney('income')" />
          </el-tooltip>
        </template>

        <template slot="quitAmount">
          <el-tooltip class="item" effect="dark" :content="changesNumber['quitAmount']" placement="top-start">
            <el-input placeholder="请输入退出金额" v-model="formData['quitAmount']" @input="getNumMoney('quitAmount')" />
          </el-tooltip>
        </template>
        <template slot="files">
          <div class="file-content">
            <WordUpload
              @showFileName="showFileName"
              fileMenuName="动态文件"
              :id="eventId&&eventId!=''?eventId:inventedId"
              :plain="true"
              :tip="true"
              :show-file-list="true"
            />
            <div class="" v-if="fileLists.length>0">
              <div v-for="(item, index) in fileLists" :key="index">
                <div class="file_wrapper" >
                  <a
                    class="file_button"
                    target="_blank"
                    :href="item.fileUrl.indexOf('http://') < 0?'http://doc.taizhoujintou.com:18888/office/xdoc?doc='+item.fileUrl:item.fileUrl"
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'file')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </avue-form>

      <!-- 分红 -->  
      <avue-form
        v-if="addType == 2"
        ref="basicInfo"
        v-model="formData"
        :option="investConfig['bonusConfig']"
      >
        <template slot="bonusAmount">
          <el-tooltip class="item" effect="dark" :content="changesNumber['bonusAmount']" placement="top-start">
            <el-input placeholder="请输入退出金额" v-model="formData['bonusAmount']" @input="getNumMoney('bonusAmount')" />
          </el-tooltip>
        </template>
        <template slot="files">
          <div class="file-content">
            <WordUpload
              @showFileName="showFileName"
              fileMenuName="动态文件"
              :id="eventId&&eventId!=''?eventId:inventedId"
              :plain="true"
              :tip="true"
              :show-file-list="true"
            />
            <div class="" v-if="fileLists.length>0">
              <div v-for="(item, index) in fileLists" :key="index">
                <div class="file_wrapper" >
                  <a
                    class="file_button"
                    target="_blank"
                    :href="item.fileUrl.indexOf('http://') < 0?'http://doc.taizhoujintou.com:18888/office/xdoc?doc='+item.fileUrl:item.fileUrl"
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'file')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </avue-form> 
       <!-- 出资动态 -->  
       <avue-form
        v-if="addType == 3"
        ref="basicInfo"
        v-model="formData"
        :option="investConfig['contributionConfig']"
      >
        <template slot="fundedAmount">
          <el-tooltip class="item" effect="dark" :content="changesNumber['fundedAmount']" placement="top-start">
            <el-input placeholder="请输入出资金额" v-model="formData['fundedAmount']" @input="getNumMoney('fundedAmount')" />
          </el-tooltip>
        </template>
        <template slot="fundedName">
            <SelectInput
              bindLabel="name"
              :allowCreate="false"
              searchKey="dictValue"
              bindKey="id"
              methods="get"
              dataMethod="params"
              dataUrl="fund/master/page"
              @handleChange="(el) => changeFundedId(el)"
              :bindId="formData['fundedId'] ? formData['fundedId'] : ''"
            />
          </template>
        
      </avue-form> 
      <!-- 分配动态 -->  
      <avue-form
        v-if="addType == 4"
        ref="basicInfo"
        v-model="formData"
        :option="investConfig['distributionConfig']"
      >
        <template slot="distributionAmount">
          <el-tooltip class="item" effect="dark" :content="changesNumber['distributionAmount']" placement="top-start">
            <el-input placeholder="请输入分配金额" v-model="formData['distributionAmount']" @input="getNumMoney('distributionAmount')" />
          </el-tooltip>
        </template>
        
        
      </avue-form> 
      <div class="submit-con">
        <el-button type="primary" @click="saveData">保存</el-button>
        <!-- <el-button type="primary" @click="">取消</el-button> -->
      </div> 
    </div>
  </div>
</template>
<script>
import {
  isvalidateMoney
} from "@/util/validate";
import WordUpload from "./wordUpload"
import CommonDetail from "@/components/commonDetail/fundCommonDetail"
import * as api from "@/api/meeting/meetingcategory";
import * as dictionaries from "@/api/zd/dictionaries"
import { downLoadTemplate } from "@/router/downLoadTem"
import { investEventConfig, stockRightConfig, quitConfig, bonusConfig,contributionConfig,distributionConfig } from "./config.js"
import {
  investEventSubmit,
  queryEventDetail,
  queryInventedId,
  queryQuitType,
  queryEventList,
  queryLeaderList
} from "@/api/fund/investEvent.js"
import SelectInput from "@/components/commonSelect/selectInput";
import util from "@/mixins/util"
export default {
  name: 'InvestEventAddContainer',
  mixins: [ util ],
  data() {
    return {
      formData: {},
      fileLists: [],
      stockRightConfig: stockRightConfig(),
      quitConfig: quitConfig(),
      bonusConfig: bonusConfig(),
      contributionConfig: contributionConfig(),
      distributionConfig: distributionConfig(),
      investConfig: investEventConfig(isvalidateMoney),
      changesNumber: {
        investCost: '请输入',
        quitCost: '请输入',
        income: '请输入',
        quitAmount: '请输入',
        bonusAmount: '请输入',
        fundedAmount: '请输入',
        distributionAmount: '请输入'
      },      
    }
  },
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    addType: {
      type: String,
      required: true
    },
    eventBelongType: {
      type: String,
      default: 1
    },
    eventId: {
      type: String,
      default: ''
    }
  },
  components:{
    CommonDetail,
    WordUpload,
    SelectInput
  },  
  mounted() {
    this.startEvent()
  },
  activated() {
    this.startEvent()
  },
  methods: {
    cleanData() {
      this.formData = {
        eventTime: '',
        investType: '',
        investRound: '',
        leader: '',
        stockType: '',
        investTag: '',
        investCost: '',
        stockAmount: '',
        stockTotal: '',
        stockRatio: '',
        files: [],
        quitType: '',
        quitCost: '',
        income: '',
        quitAmount: '',
        bonusAmount: '',
        projectName: '',
        fundedName: '',
        fundedId: '',
        fundedAmount:'',
        distributionSource:'',
        distributionAmount:''
      }
      this.eventId = ''
      this.$refs.basicInfo.clearValidate()
      this.startEvent()
    },

    getFileMenuByName() {
      let fileMenuName = '动态文件'
      let id = this.eventId&& this.eventId!=''?this.eventId:this.inventedId
      dictionaries
        .getFileMenuByName({ fileMenuName })
        .then((res) => {
          let baFileMenuId = res.data.data.id;
          api
            .findFileByOtherId({ fileOtherId:id,baFileMenuId: baFileMenuId})
            .then((datas) => {
              // this.$emit("showFileName",datas.data.data,this.index)
              this.showFileName(datas.data.data)
            })
            .catch((datas) => {
              this.loading=false
              
            });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    
    async startEvent() {
      let self = this
      // 判断当前新增类型
      // this.formData['files'] = []
      // 查询当前投资方式字典(dicUrl无法生效)
      let quitType = await queryQuitType()
      queryEventList().then(res => {
        // 更新字典
        if(!this.isDetail) {
          self.$refs["basicInfo"].updateDic("quitType", quitType["data"]["data"]);
          self.$refs["basicInfo"].updateDic("investType", res["data"]["data"]);
        }
        queryLeaderList().then(leaderRes => {
          if(!this.isDetail) self.$refs["basicInfo"].updateDic("leader", leaderRes["data"]["data"]);
          if(this.eventId && this.eventId != ''){
            self.eventId = this.eventId
            self.getEventDetail(this.eventId)
          }else{
            self.getInventedId()
          }
        })

      })      
    },
    // 获取虚拟ID
    getInventedId() {
      let self = this
      queryInventedId().then(res => {
        if(res['data']['code'] == 200){
          self.inventedId = res['data']['data']
        }
      })
    },

    getNumMoney(part) {
      if(this.formData[part]){
        let self = this
        let number = this.changeNumMoneyToChinese(this.formData[part])
        self.changesNumber[part] = number
      }else{
        self.changesNumber[part] = '请输入'
      }
    },

    // 查询动态详情
    getEventDetail(eventId) {
      let self = this
      let params = {
        eventType: this.addType,
        projectId: this.id,
        id: eventId
      }
      queryEventDetail(params).then(async (res) => {
        if(res['data']['code'] == 200){
          let data = res['data']['data']
          // 处理数据
          if(self.addType == 0){
            self.formData = {
              ...data['invest'],
              projectName: data.projectName,
              createTime: data.createTime,
              updateTime: data.updateTime
            }
            self.formData['investCostStr'] = self.getMoney(Number(data['invest']['investCost'])/10000)
            self.formData['leader'] = data['invest']['leader'].toString()
            self.formData['investType'] = data['invest']['investType'].toString()
            self.formData['investTypeStr'] = await self.queryDict(data['invest']['investType'], '/api/blade-system/dict-biz/dictionary?code=fee_collection_method')
            self.formData['leader'] = data['invest']['leader'].toString()
          } else if(self.addType == 1){
            self.formData = {
              ...data['quit'],
              projectName: data.projectName,
              createTime: data.createTime,
              updateTime: data.updateTime
            }
            self.formData.quitType = self.formData.quitType.toString()
            self.formData.quitTypeStr = await self.queryDict(data['quit']['quitType'], '/api/blade-system/dict-biz/dictionary?code=fd_event_quit_type')
            self.formData.quitAmountStr = self.getMoney(Number(data['quit']['quitAmount'])/10000)
          } else if(self.addType == 2){
            self.formData = {
              ...data['bonus'],
              projectName: data.projectName,
              createTime: data.createTime,
              updateTime: data.updateTime
            }
            self.formData.bonusAmountStr = self.getMoney(Number(data['bonus']['bonusAmount'])/10000) 
          }else if(self.addType == 3){
            self.formData = {
              ...data['funded'],
              projectName: data.projectName,
              createTime: data.createTime,
              updateTime: data.updateTime
            }
            self.formData.fundedName = data['funded'].fundedName
            self.formData.fundedAmountStr = self.getMoney(Number(data['funded']['fundedAmount'])/10000) 
          }else if(self.addType == 4){
            self.formData = {
              ...data['distribution'],
              projectName: data.projectName,
              createTime: data.createTime,
              updateTime: data.updateTime
            }
            self.formData.distributionAmountStr = self.getMoney(Number(data['distribution']['distributionAmount'])/10000) 
          }
          self.getFileMenuByName()
          self.formData['eventTime'] = data['eventTime']
        }
      })

    },

    showFileName(data, index) {
      this.formData['files'] = data;
      this.fileLists = data
    },

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
       //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.fileLists.splice(index, 1)
          this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },

    saveData() {
      let self = this
      let params = {}
      // 校验表单
      this.$refs['basicInfo'].validate((valid,done) => {
        if(valid){
          done()
          params['eventTime'] = self.formData['eventTime']
          params['eventBelongType'] = self.eventBelongType
          params['eventType'] = self.addType
          params['projectId'] = self.id
          if(this.eventId && this.eventId !== '') params['id'] = this.eventId
          // 校验数据
          let part = this.addType == 0 ? 'invest':this.addType == 1?'quit':this.addType == 2?'bonus':this.addType == 3?'funded':'distribution'
          params[part] = self.formData
          if(this.addType == 0){
            params[part]['stockRatio'] = parseFloat(self.formData['stockRatio'])
          }
          // 添加ID， 若有传入eventID，赋值eventID，否则赋值inventedId
          params = self.setId(params, part)
          // 投资方式显示无法转义问题
          // if(isNaN(self.formData['investType'])){
          //   self.formData['investType'] = self.formData['investTypeTran']
          // }
          investEventSubmit(params).then(res => {
            if(res['data']['code'] == 200){
              self.$message({
                type: "success",
                message: res['data']['msg']
              })
              // 返回动态列表
              // self.$router.push({
              //   path: '/fund/investEventManage/investEventManage'
              // })
              // 关闭当前添加页
              self.$emit('addSuccess')
            }
          })          
        }
      })

    },

    setId(params, part) {
      if(this.inventedId && this.inventedId != ''){
        params['id'] = this.inventedId
        params[part]['id'] = this.inventedId
      } else {
        params['id'] = this.eventId
        params[part]['id'] = this.eventId
      }
      return params
    },
    changeFundedId(el) {
      if (el) {
        this.formData.fundedId = el.id;
        this.formData.fundedName = el.name;
      }
    },

  }
}
</script>
<style lang="scss">
.event-add-container{
  .del_icon{
    cursor: pointer;
  }
  i.el-icon-download.del_icon {
      margin: 0 10px 0 60px;
  }
  .el-card__header{
    background: rgb(249,249,249) !important;
  }  
  .box-card{
    background-color: #fff;
    .red-point{
      color: red;
    }
    .box-header{
      // background: rgb(249,249,249);
      padding: 10px 5px;
    }
    .box-header-title{
      color: rgb(51,51,51);
      font-weight: 400;
      font-size: 16px;
    }
  } 
  .detail-one{
    padding: 10px 20px !important;
    .detail-top{
      padding: 20px 5px;
      .detail-title{
        color: #666;
        font-weight: 700;
        font-size: 16px;
        line-height: 28px;
        position: relative;
      }
      .detail-title::before{
        content: '';
        width: 5px;
        background-color: #409EFF;
        height: 18px;
        position: absolute;
        left: -12px;
        top: 5px;
      }
    }
  }
  .submit-con{
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
    button{
      width: 150px;
    }
  }
}
</style>